import React from 'react'
import { getThirdPartyLicensesHaynes } from 'app/settings/state/ThirdPartyLicenses/actions'
import maxBy from 'lodash/fp/maxBy'
import moment from 'moment'
import { useQuery } from '@tanstack/react-query'
import { useDispatch } from 'react-redux'
import { usePersistedState } from '@cbgms/base/hooks/persisted-state/use-persisted-state'

const STALE_TIME = 5 * 60 * 1000
const CACHE_TIME = 10 * 60 * 1000

export function useHaynesLicenses() {
  const dispatch = useDispatch()
  const [acknowledgedExpiry, setAcknowledgedExpiry] = usePersistedState(`ack-haynespro-license-expiry`, '')

  const licenses = useQuery(['HaynesProLicenses'], () => dispatch(getThirdPartyLicensesHaynes()), {
    refetchOnWindowFocus: false,
    staleTime: STALE_TIME,
    cacheTime: CACHE_TIME
  })
  const hasLicense = licenses.data?.Data
  const last = hasLicense && maxBy(l => l.EndDate, licenses.data?.Data)
  const expiryDate = last?.EndDate || ''
  const isExpiring = last && moment(expiryDate).diff(moment(), 'days') < 30
  const isAcknowledged = expiryDate === acknowledgedExpiry
  const acknowledgeExpiry = React.useCallback(() => setAcknowledgedExpiry(expiryDate || ''), [expiryDate])

  return { licenses: licenses.data?.Data, expiryDate, isExpiring, isAcknowledged, acknowledgeExpiry }
}
